import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_paid_for_all_workrelated_activities_outside_of_regula'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_paid_for_all_workrelated_activities_outside_of_regula',
  name: 'Are workers paid for all work-related activities outside of regular working hours?',
  description:
    'The intent of this question is to understand if the facility pays workers for all work-related activities that are outside of regular working activities and hours. \r\r\n\r\r\nFor example, work-related activities might include production meetings, training sessions, cleaning of production areas, production preparation, putting on personal protective equipment, installing machinery protections, breastfeeding breaks, etc.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7590,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
